"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const hopper_types_1 = require("./hopper.types");
const initialState = {
    isSuccess: false,
    isLoading: true,
    isError: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataEnumHopper: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        hopper: '',
        hopper_type: '',
        description: '',
        is_active: true,
        created_by: '',
        modified_by: '',
        target_lead_time: '',
        target_queue_time: '',
        target_lead_time_display: '',
        target_queue_time_display: '',
        created_date: new Date(),
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const hopperReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hopper_types_1.hopperTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hopper_types_1.hopperTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [hopper_types_1.hopperTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [hopper_types_1.hopperTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [hopper_types_1.hopperTypes.ON_DELETE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [hopper_types_1.hopperTypes.SET_DATA_ENUM_HOPPER]: (state, action) => {
        const hopper_data = action.payload.find(x => x.value === state.dataItem.hopper_type) ||
            {
                id: '',
                type: '',
                value: '',
                is_active: false,
                created_by: '',
                created_date: new Date(),
                modified_by: '',
                modified_date: new Date()
            };
        return Object.assign(Object.assign({}, state), { dataEnumHopper: action.payload, dataItem: Object.assign(Object.assign({}, state.dataItem), { hopper_data, hopper_type: hopper_data.id }) });
    },
    [hopper_types_1.hopperTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [hopper_types_1.hopperTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [hopper_types_1.hopperTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isError,
            errorCode,
            errorMessage, isSuccess: false });
    },
    [hopper_types_1.hopperTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    }
});
exports.default = hopperReducer;
